export { default as UserAvatar } from './UserAvatar';
